import { render } from "./SFormElementCheckbox.vue?vue&type=template&id=3872f581&scoped=true&ts=true"
import script from "./SFormElementCheckbox.vue?vue&type=script&lang=ts"
export * from "./SFormElementCheckbox.vue?vue&type=script&lang=ts"

import "./SFormElementCheckbox.vue?vue&type=style&index=0&id=3872f581&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3872f581"]])

export default __exports__